import { Button, TableCell, TableRow, TableRowHeader } from '@/common'
import useI18n from '@/shared/hooks/useI18n'
import LocalizedNumberFlow from '@/components/LocalizednNumberFlow'
import { MassBalanceItem } from '@/api/EmissionReportModel'
import { TrashIcon } from '@/common/components/icons'

export default function InputTableRow({
  item,
  title,
  onRemove,
  id,
  index,
  onEdit,
  isViewMode
}: {
  index: number
  id: string
  item: MassBalanceItem
  title: string
  onEdit?: (index: number) => void
  onRemove?: (index: number) => void
  isViewMode: boolean
}) {
  const { t } = useI18n()

  return (
    <TableRow key={id}>
      {index === 0 ? (
        <TableRowHeader className="font-semibold">{title}</TableRowHeader>
      ) : (
        <TableCell />
      )}
      <TableCell>{item.materialName}</TableCell>
      <TableCell>{item.description}</TableCell>
      <TableCell>
        <LocalizedNumberFlow value={item.quantity} />
      </TableCell>
      <TableCell>
        <LocalizedNumberFlow value={item.emission} />
      </TableCell>
      <TableCell>
        <div className="grid grid-cols-2 gap-2">
          {onEdit && (
            <Button
              variant="txt-default"
              sizeType="sm"
              onClick={() => onEdit?.(index)}
              disabled={isViewMode}
            >
              {t('common:actions.edit')}
            </Button>
          )}
          {onRemove && (
            <Button
              className="text-center"
              variant="txt-danger"
              sizeType="sm"
              onClick={() => onRemove?.(index)}
              disabled={isViewMode}
            >
              <TrashIcon className="inline-block size-5" />
            </Button>
          )}
        </div>
      </TableCell>
    </TableRow>
  )
}
